<div *ngIf="dataFrontend && data && dataChanges && dataNew">
  <h2 mat-dialog-title>
    <mat-icon
      style="
      margin-bottom: 12px;
      vertical-align: bottom;
      font-size: 40px;
      margin-right: 20px;
    "
    >compare_arrows
    </mat-icon
    >
    {{ dataFrontend.length }} objekter klare for import ({{ dataNew.length }} nye, {{ dataChanges.length }} endrede)
  </h2>


  <mat-button-toggle-group
    style="width: 100%; margin-bottom: 15px"
    [value]="key"
    name="keySelector"
    aria-label="Select key"
    appearance="legacy"
  >
    <mat-button-toggle
      style="width: 100%; padding: 5px"
      value="all"
      matTooltip="Alle"
      (click)="updateKey('all')"
    >
      <mat-icon color="primary" class="tab-icon">
        auto_awesome_motion
      </mat-icon>
      Alle
      <p-badge [value]="data.length"
               [style]="{ 'background-color': '#444', 'color': '#ccc', 'margin-left': '10px', 'margin-right': '-10px' }"></p-badge>
    </mat-button-toggle>
    <mat-button-toggle
      style="width: 100%; padding: 5px"
      value="new"
      matTooltip="Nye"
      (click)="updateKey('new')"
    >
      <mat-icon color="primary" class="tab-icon">
        add_circle
      </mat-icon>
      Nye
      <p-badge [value]="dataNew.length"
               [style]="{ 'background-color': '#444', 'color': '#ccc', 'margin-left': '10px', 'margin-right': '-10px' }"></p-badge>
    </mat-button-toggle>
    <mat-button-toggle
      style="width: 100%; padding: 5px"
      value="changes"
      matTooltip="Endrede"
      (click)="updateKey('changes')"
    >
      <mat-icon color="primary" class="tab-icon">
        edit
      </mat-icon>
      Endrede
      <p-badge [value]="dataChanges.length"
               [style]="{ 'background-color': '#444', 'color': '#ccc', 'margin-left': '10px', 'margin-right': '-10px' }"></p-badge>
    </mat-button-toggle>
    <mat-button-toggle
      style="width: 100%; padding: 5px"
      value="error"
      matTooltip="Feil"
      (click)="updateKey('error')"
    >
      <mat-icon [color]="dataError.length > 0 ? 'warn' : 'primary'" class="tab-icon">
        error
      </mat-icon>
      Feil
      <p-badge [value]="dataError.length"
               [style]="{ 'background-color': '#444', 'color': '#ccc', 'margin-left': '10px', 'margin-right': '-10px' }"></p-badge>
    </mat-button-toggle>
  </mat-button-toggle-group>

  <mat-dialog-content>
    <div *ngIf="dataFrontend">

      <p-table [value]="dataFrontend"
               [scrollable]="true"
               [scrollHeight]="'500px'"
               #pTable
               [paginator]="true"
               [alwaysShowPaginator]="true"
               paginatorDropdownAppendTo="body"
               [rows]="25"
               [showCurrentPageReport]="true"
               currentPageReportTemplate="{first} - {last} / {totalRecords}"
               [rowsPerPageOptions]="[10, 25, 50, 100]"
               styleClass="p-datatable-striped p-datatable-sm"
      >
        <ng-template pTemplate="header">
          <tr style="text-align: left">
            <th></th>
            <th style="border-bottom: 1px solid #666">Prosess</th>
            <th style="border-bottom: 1px solid #666">Navn</th>
            <th style="border-bottom: 1px solid #666">TFM Tag</th>
            <th style="border-bottom: 1px solid #666">RDS Tag</th>
            <th style="border-bottom: 1px solid #666; max-width: 200px">Type</th>
            <th style="border-bottom: 1px solid #666">Beskrivelse</th>
            <th style="border-bottom: 1px solid #666">Profilnummer</th>
            <th style="border-bottom: 1px solid #666">Tegning</th>
            <th style="border-bottom: 1px solid #666">Kommentar</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-d let-islast="last">
          <tr [ngClass]="{'errortext': d.change === 'error'}">
            <td>
              <mat-icon
                class="noselect"
                style="margin-right: 10px;"
                [style.opacity]="d.change === 'error' ? 1 : 0.2"
                *ngIf="d.change === 'error'"
                matTooltip="Finner ikke objekt i prosjektet"
                [ngStyle]="{'color': d.change === 'error' ? 'warn' : 'primary'}"
              >{{ d.change === 'error' ? 'error' : 'add' }}
              </mat-icon
              >
            </td>
            <td [style.border-bottom]="islast ? '' : '1px solid #666'">
              <div *ngIf="d.old_process" style="opacity: 0.3" class="strikethrough">
                {{ d.old_process }}
              </div>
              <mat-icon color="primary" *ngIf="d.old_process === '' && d.old_process !== d.process">add_circle
              </mat-icon>
              <mat-icon color="primary" *ngIf="safeTrim(d.old_process) !== '' && d.old_process !== d.process">edit
              </mat-icon>
              {{ d.process }}
            </td>
            <td [style.border-bottom]="islast ? '' : '1px solid #666'">
              <div *ngIf="d.old_name" style="opacity: 0.3" class="strikethrough">
                {{ d.old_name }}
              </div>
              <mat-icon color="primary" *ngIf="d.old_name === '' && d.old_name !== d.name">add_circle</mat-icon>
              <mat-icon color="primary" *ngIf="safeTrim(d.old_name) !== '' && d.old_name !== d.name">edit
              </mat-icon>
              {{ d.name }}
              <div *ngIf="safeTrim(d.name) === ''">
                <p-tag icon="pi pi-exclamation-triangle" value="Mangler navn" severity="danger" [style]="{'background-color': '#d33030'}" />
              </div>
            </td>
            <td [style.border-bottom]="islast ? '' : '1px solid #666'">
              <div *ngIf="d.old_tfmTag" style="opacity: 0.3" class="strikethrough">
                {{ d.old_tfmTag }}
              </div>
              <mat-icon color="primary" *ngIf="d.old_tfmTag === '' && d.old_tfmTag !== d.tfmTag">add_circle</mat-icon>
              <mat-icon color="primary" *ngIf="safeTrim(d.old_tfmTag) !== '' && d.old_tfmTag !== d.tfmTag">
                edit
              </mat-icon>
              {{ d.tfmTag }}
              <div *ngIf="duplicateTfmTags.includes(d.tfmTag)">
                <p-tag icon="pi pi-exclamation-triangle" value="DUPLIKAT" severity="danger" [style]="{'background-color': '#d33030'}" />
              </div>
            </td>
            <td [style.border-bottom]="islast ? '' : '1px solid #666'">
              <div *ngIf="d.old_rdsTag" style="opacity: 0.3" class="strikethrough">
                {{ d.old_rdsTag }}
              </div>
              <mat-icon color="primary" *ngIf="d.old_rdsTag === '' && d.old_rdsTag !== d.rdsTag">add_circle</mat-icon>
              <mat-icon color="primary" *ngIf="safeTrim(d.old_rdsTag) !== '' && d.old_rdsTag !== d.rdsTag">
                edit
              </mat-icon>
              {{ d.rdsTag }}
              <div *ngIf="duplicateRdsTags.includes(d.rdsTag)">
                <p-tag icon="pi pi-exclamation-triangle" value="DUPLIKAT" severity="danger" [style]="{'background-color': '#d33030'}" />
              </div>
            </td>
            <td
              style="max-width: 200px"
              [style.border-bottom]="islast ? '' : '1px solid #666'"
            >
              <div *ngIf="d.old_type?.name" style="opacity: 0.3" class="strikethrough">
                {{ d.old_type.name }}
              </div>
              <mat-icon
                class="noselect"
                color="warn"
                *ngIf="!d.type"
                matTooltip="Mangler type"
              >warning
              </mat-icon
              >
              <div *ngIf="d.change === 'error'">{{ d.type?.name }}</div>
              <mat-icon color="primary" *ngIf="!isLoading && d.change !== 'error' && objecttypes && d.old_type">edit
              </mat-icon>
              {{ d.type?.name }}
              <form
                *ngIf="!isLoading && d.change !== 'error' && objecttypes && (d.old_type || !d.type?.name)"
                style="max-width: 200px"
              >
                <mat-form-field>
                  <mat-label>Endre objekttype</mat-label>
                  <mat-select [(value)]="d.type">
                    <mat-option *ngFor="let item of objecttypes" [value]="item">
                      {{ item.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="type.touched && type.invalid">
                    <div *ngIf="!type.errors.required">Please select a type</div>
                    <div *ngIf="type.errors.required">
                      Object type is <strong>required</strong>
                    </div>
                  </mat-error>
                </mat-form-field>
              </form>
              <div *ngIf="safeTrim(d.type?.name) === ''">
                <p-tag icon="pi pi-exclamation-triangle" value="Mangler type" severity="danger" [style]="{'background-color': '#d33030'}" />
              </div>
            </td>
            <td [style.border-bottom]="islast ? '' : '1px solid #666'">
              <div *ngIf="d.old_desc" style="opacity: 0.3" class="strikethrough">
                {{ d.old_desc }}
              </div>
              <mat-icon color="primary" *ngIf="d.old_desc === '' && d.old_desc !== d.desc">add_circle</mat-icon>
              <mat-icon color="primary" *ngIf="d.old_desc && d.old_desc.trim() !== '' && d.old_desc !== d.desc">edit
              </mat-icon>
              {{ d.desc }}
            </td>
            <td [style.border-bottom]="islast ? '' : '1px solid #666'">
              <div *ngIf="d.old_profilenumber" style="opacity: 0.3" class="strikethrough">
                {{ d.old_profilenumber }}
              </div>
              <mat-icon color="primary" *ngIf="d.old_profilenumber === '' && d.old_profilenumber !== d.profilenumber">
                add_circle
              </mat-icon>
              <mat-icon color="primary"
                        *ngIf="d.old_profilenumber && d.old_profilenumber.trim() !== '' && d.old_profilenumber !== d.profilenumber">
                edit
              </mat-icon>
              {{ d.profilenumber }}
            </td>
            <td [style.border-bottom]="islast ? '' : '1px solid #666'">
              <div *ngIf="d.old_drawing" style="opacity: 0.3" class="strikethrough">
                {{ d.old_drawing }}
              </div>
              <mat-icon color="primary" *ngIf="d.old_drawing === '' && d.old_drawing !== d.drawing">add_circle
              </mat-icon>
              <mat-icon color="primary"
                        *ngIf="d.old_drawing && d.old_drawing.trim() !== '' && d.old_drawing !== d.drawing">edit
              </mat-icon>
              {{ d.drawing }}
            </td>
            <td [style.border-bottom]="islast ? '' : '1px solid #666'">
              <div *ngIf="d.old_comment" style="opacity: 0.3" class="strikethrough">
                {{ d.old_comment }}
              </div>
              <mat-icon color="primary" *ngIf="d.old_comment === '' && d.old_comment !== d.comment">add_circle
              </mat-icon>
              <mat-icon color="primary"
                        *ngIf="d.old_comment && d.old_comment.trim() !== '' && d.old_comment !== d.comment">edit
              </mat-icon>
              {{ d.comment }}
            </td>
          </tr>
        </ng-template>
      </p-table>

    </div>

  </mat-dialog-content>
  <div style="text-align: end; margin: 10px;">
    <mat-error *ngIf="dataError.length > 0">{{ errorMessage }}
    </mat-error>
  </div>
  <mat-dialog-actions align="end">
    <!-- <div class="row">
      <div class="fill-space"></div> -->
    <!-- <div> -->
    <button
      [disabled]="objectnotfound > 0 || disableButtons"
      mat-raised-button
      (click)="downloadChangeInObjects()"
    >
      <mat-icon>save_alt</mat-icon>
      Last ned endringsliste
    </button>
    <button
      [disabled]="objectnotfound > 0 || !readyToSave || disableButtons"
      mat-raised-button
      (click)="saveObjects()"
    >
      <mat-icon color="primary">check</mat-icon>
      Utfør import
    </button>
    <!-- </div> -->
    <!-- </div> -->
  </mat-dialog-actions>
  <div class="row" style="margin-top: 25px">
    <div class="fill-space"></div>
    <div class="errortext" *ngIf="objectnotfound > 0">
      {{ objectnotfound }} objekter ikke funnet i database. Import ikke mulig.
    </div>
  </div>
</div>
